export enum ToolCodeEnum {
  Active_Directory = 'Active_Directory',
  Swagger = 'Swagger',
  Batch_Patch = 'Batch_Patch',
  Wiki = 'Wiki',
  File_Share_Permission_Manager = 'File_Share_Permission_Manager',
  Certificate_Checker = 'Certificate_Checker',
  Data_Copy = 'Data_Copy',
  API_Client = 'API_Client',
  Database_Management = 'Database_Management',
  Web_Services_Test_Data = 'Web_Services_Test_Data',
  WebSphere = 'WebSphere',
  Model_Explorer = 'Model_Explorer',
  Db_Composer = 'Db_Composer',
  Ops_Scanner = 'Ops_Scanner',
  Azure_Devops = 'Azure_Devops',
  Promotion = 'Promotion',
  JavaPromotion = 'JavaPromotion',
  DotNETPromotion = 'DotNETPromotion',
  T_Query = 'T_Query',
  Liberty = 'Liberty',
  ReleaseDashboard = 'ReleaseDashboard',
  OSA_GPT = 'OSA_GPT',
  IIS = 'IIS'
}
